(function () {
    if (!window.retextion) {
      window.retextion = {};
    }
  
    window.retextion.product = function (options) {
      console.log('options', options)
      var formSelector = options.formSelector;
      var sellingPlanGroupsSelector = options.sellingPlanGroupsSelector;
      var sellingPlanIdInputSelector = options.sellingPlanIdInputSelector;
      var priceContainerSelector = options.priceContainerSelector;
      var regularPriceSelector = options.regularPriceSelector;
      var salePriceSelector = options.salePriceSelector;
      var variantSelectorSelector = options.variantSelectorSelector;
  
      var product = options.product;
      var groupToSellingPlans = options.groupToSellingPlans;
      var variantToPrice = options.variantToPrice;
      var variantToSellingPlanAllocations =
        options.variantToSellingPlanAllocations;
      var priceDisplayMode = options.priceDisplayMode || "strike";
      var showSubscriptionDiscountBadge = !!options.showSubscriptionDiscountBadge;
  
      var $form;
      var $sellingPlanIdInput;
  
      var variantsHandler;
      var priceDisplayHandler;
      var sellingPlanGroupsHandler;
      var quantityHandler;
  
      function initialize() {
        console.log('init should run')
        $form = document.querySelector(formSelector);
        $sellingPlanIdInput = document.querySelectorAll(
          sellingPlanIdInputSelector
        );
  
        const $variantIdInput = document.querySelector('input[name="id"]');
        const $variantSelector = document.querySelector('#productSelect')
        $variantSelector.addEventListener("change", function (e) {
          const selectedVaraint = e.target.value;
          const variantPrice = variantToPrice[selectedVaraint];
          const onetimePriceSelector = document.querySelector(
            'label[for="product_onetime"] .rtx_option_subheading'
          );
          const onetimePriceSelectorPrice = onetimePriceSelector.querySelector('.price');
          const onetimePriceSelectorComparePrice = onetimePriceSelector.querySelector('.compare-price');

          console.log(`variantPrice:`, variantPrice);
          
          onetimePriceSelectorComparePrice.textContent = variantPrice.compareAtPriceFormatted;
          if (variantPrice.compareAtPrice > variantPrice.price) {
            onetimePriceSelectorComparePrice.textContent = variantPrice.compareAtPriceFormatted;
          } else {
            onetimePriceSelectorComparePrice.textContent = '';
          }
          onetimePriceSelectorPrice.textContent = variantPrice.priceFormatted;

          console.log(`ALT DID IT`)

          var sellingPlanGroups = document.querySelectorAll(".rtx_option--sub");
          sellingPlanGroups.forEach((sellingPlanGroup) => {
            hideElement(sellingPlanGroup);
          });
          document.querySelector(".rtx_option--onetime input").checked = true;
          document.querySelector('.rtx_option--sub').classList.remove('option--active');
          document.querySelector('.rtx_option--onetime').classList.add('option--active');
          document.querySelector('.rtx_option_plans').style.display = 'none';
          document.querySelector('[name="selling_plan"]').value = '';
          const variantSellingPlanAllocations =
            variantToSellingPlanAllocations[selectedVaraint];
          if (variantSellingPlanAllocations) {
            variantSellingPlanAllocations.forEach((allocation) => {
              var sellingPlanSelector = document.querySelector(
                `.rtx_option[data-group-id="${allocation.sellingPlanGroupId}"]`
              );
              var sellingPlanSelectorPrice = document.querySelector(
                `.rtx_option[data-group-id="${allocation.sellingPlanGroupId}"] .rtx_option_subheading`
              );
              sellingPlanSelectorPrice.textContent = allocation.priceFormatted;
              showElement(sellingPlanSelector);
            });
          }
          //document.querySelector('label[for="product_onetime"]').click();
        });
  
        var productForm = document.querySelector(formSelector);
        var variantSelector = document.querySelector('.pdp-variant-selector')
        var rtxnParentBlock = document.querySelector(".rtxn-block");
        if (productForm && rtxnParentBlock) {
          var fragment = document.createDocumentFragment();
          fragment.appendChild(rtxnParentBlock);
          variantSelector.parentNode.insertBefore(fragment, variantSelector.nextSibling);
          // productForm.prepend(fragment);
        }
  
        // Utility function to easily update the selected selling plan and related elements
        function setSellingPlan() {
          var selectedVariant = document.querySelector('input[name="id"]').value;
          var selectedOption = document.querySelector(
            'input[name="selling_plan_select"]:checked'
          );
          document.querySelector('input[name="selling_plan"]').value = "";
          if (selectedOption.value === "onetime") {
            document.querySelector('input[name="selling_plan"]').value = "";
            document.querySelectorAll(".rtx_option_plans").forEach((plans) => {
              plans.style.display = "none";
            });
          } else {
            var sellingPlanDropdowns = document.querySelectorAll(
              ".rtx_option_plans_dropdown"
            );
            var sellingPlanDropdown;
            sellingPlanDropdowns.forEach((dropdown) => {
              if (!dropdown.classList.contains("hide")) {
                sellingPlanDropdown = dropdown;
              }
            });
            var sellingPlanId = sellingPlanDropdown.value;
            const variantAllocation = variantToSellingPlanAllocations[
              selectedVariant
            ].find((alloc) => alloc.sellingPlanId == sellingPlanId);
            document.querySelector(
              `.rtx_option--sub[data-group-id="${variantAllocation.sellingPlanGroupId}"] .rtx_option_subheading`
            ).textContent = variantAllocation.priceFormatted;
            document.querySelector('input[name="selling_plan"]').value =
              sellingPlanId;
            document.querySelectorAll(".rtx_option_plans").forEach((plans) => {
              plans.style.display = "block";
            });
          }
        }
  
        document
          .querySelector(".rtx_option_plans_dropdown")
          .addEventListener("change", function (e) {
            setSellingPlan();
          });
  
        document
          .querySelectorAll('input[name="selling_plan_select"]')
          .forEach((rbi) => {
            rbi.addEventListener("change", function (e) {
              var selected = document.querySelector(
                'input[name="selling_plan_select"]:checked'
              );
              var sellingPlanGroupId = selected
                .closest(".rtx_option")
                .getAttribute("data-group-id");
              document.querySelectorAll(".rtx_option").forEach((option) => {
                option.classList.remove("option--active");
              });
              selected.closest(".rtx_option").classList.add("option--active");
              if (selected.value === "onetime") {
                document
                  .querySelectorAll(".rtx_option_plans")
                  .forEach((plans) => {
                    plans.style.display = "none";
                  });
              } else {
                document
                  .querySelectorAll(".rtx_option_plans")
                  .forEach((plans) => {
                    plans.style.display = "block";
                  });
                document
                  .querySelectorAll(".rtx_option_plans select")
                  .forEach((select) => hideElement(select));
                showElement(
                  document.querySelector(
                    `.rtx_option_plans select[data-group-id="${sellingPlanGroupId}"]`
                  )
                );
              }
              setSellingPlan();
            });
          });
      }
  
      // Utility Functions
      const showElement = (element) => {
        return element.classList.remove("hide");
      };
  
      const hideElement = (element) => {
        if (
          typeof element !== "undefined" &&
          !element.classList.contains("hide")
        ) {
          return element.classList.add("hide");
        }
      };
  
      // Init
      initialize();
    };
  })();